import { ref } from "vue";

export type ModalOptions = {
  title: string;
  textBody: string;
};

export function useConfirmModal() {
  const show = ref(false);
  const title = ref("Warning");
  const textBody = ref("");
  const modalResolve = ref({} as any);

  function showModal(options: ModalOptions): Promise<boolean> {
    show.value = true;
    title.value = options.title;
    textBody.value = options.textBody;

    return new Promise(resolve => {
      modalResolve.value = resolve;
    });
  }

  return {
    show,
    title,
    textBody,
    showModal,
    modalResolve,
  };
}
